import type { TrackedTranslation } from '@ps/web-core-intl';
import type { Error } from '@ps/web-shared-validators';

import type { FieldNameProp } from '@swf/core/types/Props';

import { CITY_MAX_LENGTH, CITY_MIN_LENGTH, useCityFieldValidators } from '../../validators/city';
import TextInput from '../TextInput/TextInput';

import { TXTCLI_City } from './City.messages.json';

interface Props extends FieldNameProp {
  requiredMessage?: Error['message'];
  value?: string;
  label?: TrackedTranslation;
  className?: string;
  maxLength?: number;
  minLength?: number;
}

const City: React.FC<Props> = ({
  fieldName,
  value,
  label = TXTCLI_City,
  className,
  maxLength = CITY_MAX_LENGTH,
  minLength = CITY_MIN_LENGTH,
  requiredMessage
}) => {
  const validators = useCityFieldValidators(requiredMessage, minLength);

  return (
    <TextInput
      id={fieldName}
      label={label}
      maxLength={maxLength}
      autoComplete="off"
      value={value}
      className={className}
      checkDisabled
      validators={validators}
    />
  );
};

export default City;
